import { Modal } from 'bootstrap'
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    startVisible: { type: Boolean, default: true }
  }

  connect() {
    const options = { backdrop: 'static' }
    this.modal = new Modal(this.element, options)
    if (this.startVisibleValue) this.modal.show()
    this.element.addEventListener('hidden.bs.modal', _event => {
      this.element.remove()
    })
  }
}
